import React, { Component } from 'react';

// Material components
import { Grid } from '@material-ui/core';


class Loading extends Component {
  render() {
    return (
      <Grid container>
        <div style={{ margin: 'auto', lineHeight: '100vh', verticalAlign: 'middle' }}>
          <img src="/images/loader.svg" alt="Genomin" />
        </div>
      </Grid>
    );
  }
}

export default Loading;